import { useState } from "react";
import styles from "./styles.module.css";

function DeleteAccountModal({ onConfirm, onCancel }) {

  const [password, setPassword] = useState("");

  function handleSubmit(e){
    e.preventDefault();
    onConfirm(password);
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3>Excluir conta</h3>

        <p>Tem certeza que deseja excluir sua conta?</p>

        <div className={styles.warning}>
          ⚠️ Todos os seus dados e notas serão apagados permanentemente.
        </div>

        <form onSubmit={handleSubmit}>

          <input
            type="password"
            placeholder="Digite sua senha para confirmar"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            required
          />

          <div className={styles.buttons}>

            <button
              type="button"
              className={styles.cancel}
              onClick={onCancel}
            >
              Cancelar
            </button>

            <button
              type="submit"
              className={styles.delete}
            >
              Excluir conta
            </button>

          </div>

        </form>
      </div>
    </div>
  );
}

export default DeleteAccountModal;